module.exports = __webpack_public_path__ + "img/gc_country_flag_it.97026fb3.svg";